/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const dairy = useStore((state) => state.dairy);
  const setDairy = useStore((state) => state.setDairy);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.dairy.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={dairy}
          onChange={(value) => {
            setDairy(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'dairy',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'yes'}>
            <span>🧀</span> {t('onboarding.dairy.options.yes')}
          </Option>
          <Option value={'sometimes'}>
            <span>🥛</span> {t('onboarding.dairy.options.sometimes')}
          </Option>
          <Option value={'no'}>
            <span>🚫</span> {t('onboarding.dairy.options.no')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
